import React, { ChangeEvent, useEffect, useState } from 'react';
import { ANALYTIC, COUNT, DATA_CONFIGURATION, DEFAULT_VALUE, ENTER, MAX, MAX_COUNT, MAX_QUANTITY, MIN, MIN_COUNT, MIN_QUANTITY, QUANTITY, REQUIRED, SELECT_TYPE } from '../ISRConstants';
import { TConnector, TField, TFieldDataConfiguration, TProductCategory, TSubmodel } from '../Pages/DefineModel/model';
import ToggleButton from 'Components/Common/components/Inputs/ToggleButton';

type BooleanConfigurationProps = {
    id: string;
    selectedItem: TField | TSubmodel | TProductCategory | TConnector | null;
    updateFieldDataConfiguration: (updatedConfig: TFieldDataConfiguration) => void;
}

const BooleanConfiguration = ({id, selectedItem, updateFieldDataConfiguration}: BooleanConfigurationProps) => {
    const existingValue = selectedItem && 'dataConfiguration' in selectedItem && selectedItem?.dataConfiguration ? selectedItem.dataConfiguration : {}
    const [fieldDataConfiguration, setFieldDataConfiguration] = useState<TFieldDataConfiguration>(existingValue);
    const optionsMap = new Map([
        ['True/False', ['True', 'False']],
        ['Yes/No', ['Yes', 'No']],
        ['0/1', ['0', '1']],
    ]);

    useEffect(() => {
        const hasChanges = Object.keys(fieldDataConfiguration).some(
            (key) => fieldDataConfiguration[key as keyof TFieldDataConfiguration] !== undefined
        );
        if (hasChanges) {
            updateFieldDataConfiguration(fieldDataConfiguration);
        }
    }, [fieldDataConfiguration]);

    const handleTypeChange = (event: ChangeEvent<HTMLSelectElement>) => {
        setFieldDataConfiguration((prevConfig) => ({...prevConfig, selectType: event.target.value}));
        setFieldDataConfiguration((prevConfig) => ({...prevConfig, defaultValue: ''}));
    };

    const handleDefaultTypeChange = (event: ChangeEvent<HTMLSelectElement>) => {
        setFieldDataConfiguration((prevConfig) => ({...prevConfig, defaultValue: event.target.value}));
    }

    const handleRequiredChange = (value: boolean) => {
        setFieldDataConfiguration((prevConfig) => ({...prevConfig, fieldRequired: value}));
    }

    const handleAnalyticChange = (value: boolean) => {
        setFieldDataConfiguration((prevConfig) => ({...prevConfig, enableAnalytic: value}));
    }

    const handleMinMaxFields = (value: number, property: string) =>{
        setFieldDataConfiguration((prevConfig) => {
            if(!prevConfig) return prevConfig
            const updatedData = {
                ...prevConfig,
                [property]: value
            }
            return updatedData
        })
    }

    return (
        <React.Fragment>
            <div id={id} className='cart-style-dm'>
                <label id={`${id}-title`} className='cart-title'>{DATA_CONFIGURATION}</label>
                <div id={`${id}-main-section`} className='tw-flex tw-items-center tw-mt-3'>
                    <div id={`${id}-select-type-container`} className='tw-w-[15%]'>
                        <label id={`${id}-select-type-label`} className='tw-text-sm tw-text-[#747593] tw-block'>{SELECT_TYPE}</label>
                        <select 
                            id={`${id}-select-type`}
                            className="drop-down-dm" 
                            value={fieldDataConfiguration?.selectType ?? ''} 
                            onChange={handleTypeChange}
                        >
                            <option id={`${id}-select-default`}>Select</option>
                            {['True/False', 'Yes/No', '0/1'].map((item, index) => (
                                <option id={`${id}-select-option-${index}`} value={item} key={item + index}>
                                    {item}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div id={`${id}-default-value-container`} className='tw-w-[15%] tw-ms-5'>
                        <label id={`${id}-default-value-label`} className='tw-text-sm tw-text-[#747593] tw-block'>{DEFAULT_VALUE}</label>
                        <select 
                            id={`${id}-default-value-select`}
                            className="drop-down-dm" 
                            value={fieldDataConfiguration.defaultValue ?? ''} 
                            onChange={handleDefaultTypeChange}
                        >
                            <option id={`${id}-default-value-option`}>Select</option>
                            {fieldDataConfiguration?.selectType &&
                                optionsMap.get(fieldDataConfiguration.selectType)?.map((item, index) => (
                                    <option id={`${id}-default-value-option-${index}`} value={item} key={item + index}>
                                        {item}
                                    </option>
                                ))
                            }
                        </select>
                    </div>
                    <div id={`${id}-required-container`} className='tw-w-[10%] tw-ms-5'>
                        <label id={`${id}-required-label`} className='tw-text-sm tw-text-[#747593] tw-block tw-mb-1.5'>{REQUIRED}</label>
                        <ToggleButton
                            id={`${id}-required-toggle`}
                            name="Required" 
                            value={fieldDataConfiguration?.fieldRequired ?? false} 
                            onChange={(e) => handleRequiredChange(e.target.checked)} 
                        />
                    </div>
                    {/* <div id={`${id}-analytic-container`} className='tw-w-[10%]'>
                        <div className='tw-flex tw-items-center tw-gap-1 tw-mb-1.5'>
                            <label id={`${id}-analytic-label`} className='tw-text-sm tw-text-[#747593] tw-block tw-mb-1'>{ANALYTIC}</label>
                        </div>
                        <ToggleButton
                            id={`${id}-analytic-toggle`}
                            name={ANALYTIC}
                            value={fieldDataConfiguration?.enableAnalytic ?? false}
                            onChange={(e) => handleAnalyticChange(e.target.checked)} 
                        />
                    </div> */}
                </div>
                <>
                    <label id={`${id}-count-title`} className='cart-title tw-mt-2'>{COUNT}</label>
                    <div id={`${id}-count-container`} className='tw-flex tw-items-center tw-mt-2'>
                        <div id={`${id}-count-min-container`} className='tw-w-[20%]'>
                            <label id={`${id}-count-min-label`} className='tw-text-sm tw-text-[#747593] tw-block'>{MIN}</label>
                            <input
                                id={`${id}-count-min-input`}
                                className="input-field-dm"
                                type='number'
                                value={fieldDataConfiguration?.minCount ?? 0}
                                onChange={(e) => handleMinMaxFields(Number(e.target.value), MIN_COUNT)}
                                placeholder={ENTER} 
                            />
                        </div>
                        <div id={`${id}-count-max-container`} className='tw-w-[20%] tw-ms-5'>
                            <label id={`${id}-count-max-label`} className='tw-text-sm tw-text-[#747593] tw-block'>{MAX}</label>
                            <input
                                id={`${id}-count-max-input`}
                                className="input-field-dm"
                                type='number'
                                value={fieldDataConfiguration?.maxCount ?? 0}
                                onChange={(e) => handleMinMaxFields(Number(e.target.value), MAX_COUNT)}
                                placeholder={ENTER} 
                            />
                        </div>
                    </div>
                    <label id={`${id}-quantity-title`} className='cart-title tw-mt-2'>{QUANTITY}</label>
                    <div id={`${id}-quantity-container`} className='tw-flex tw-items-center tw-mt-2'>
                        <div id={`${id}-quantity-min-container`} className='tw-w-[20%]'>
                            <label id={`${id}-quantity-min-label`} className='tw-text-sm tw-text-[#747593] tw-block'>{MIN}</label>
                            <input
                                id={`${id}-quantity-min-input`}
                                className="input-field-dm"
                                type='number'
                                value={fieldDataConfiguration?.minQuantity ?? 0}
                                onChange={(e) => handleMinMaxFields(Number(e.target.value), MIN_QUANTITY)}
                                placeholder={ENTER} 
                            />
                        </div>
                        <div id={`${id}-quantity-max-container`} className='tw-w-[20%] tw-ms-5'>
                            <label id={`${id}-quantity-max-label`} className='tw-text-sm tw-text-[#747593] tw-block'>{MAX}</label>
                            <input
                                id={`${id}-quantity-max-input`}
                                className="input-field-dm"
                                type='number'
                                value={fieldDataConfiguration?.maxQuantity ?? 0}
                                onChange={(e) => handleMinMaxFields(Number(e.target.value), MAX_QUANTITY)}
                                placeholder={ENTER} 
                            />
                        </div>
                    </div>
                </>
            </div>
        </React.Fragment>
    );
}

export default BooleanConfiguration;